import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ConsultationFormAssignmentResponse,
  ConsultationFormResponse,
  IntakeFormApi,
  IntakeFormRequest,
  Page,
  SaveIntakeFormProgressRequest,
  SignIntakeFormRequest,
} from '@models';
import { map, Observable } from 'rxjs';
import { HttpService } from '../http.service';
import { withGuardianCalloutResponse } from './guardian-callout.util';
import { IntakeFormsService } from './intake-forms.interface';

@Injectable({
  providedIn: 'root',
})
export class IntakeFormsApiService
  extends HttpService<IntakeFormApi>
  implements IntakeFormsService
{
  protected override readonly collectionPath = '/consultation-form/submissions';

  getIntakeForms(params: IntakeFormRequest): Observable<Page<IntakeFormApi>> {
    return this.getCollectionByQuery(
      params as unknown as Record<string, string | number | boolean | undefined>
    );
  }

  getIntakeForm(
    id: string,
    options?: { headers: HttpHeaders }
  ): Observable<ConsultationFormResponse> {
    return this.http
      .get<ConsultationFormResponse>(`${this.apiUrl}/${id}`, options)
      .pipe(map(withGuardianCalloutResponse));
  }

  assignToPatient(
    patientId: string
  ): Observable<ConsultationFormAssignmentResponse> {
    return this.http.post<ConsultationFormAssignmentResponse>(this.apiUrl, {
      patientId,
    });
  }

  sign(
    submissionId: string,
    body: SignIntakeFormRequest,
    options?: { headers: HttpHeaders }
  ): Observable<string> {
    return this.http.patch<string>(
      `${this.apiUrl}/${submissionId}`,
      body,
      options
    );
  }

  saveProgress(
    submissionId: string,
    body: SaveIntakeFormProgressRequest
  ): Observable<unknown> {
    return this.http.patch<unknown>(`${this.apiUrl}/${submissionId}`, body);
  }

  complete(
    submissionId: string,
    body: SignIntakeFormRequest
  ): Observable<unknown> {
    return this.http.post<unknown>(
      `${this.apiUrl}/${submissionId}/complete`,
      body
    );
  }

  deleteSubmission(submissionId: string): Observable<unknown> {
    return this.deleteItemById(submissionId);
  }

  getPdf(
    submissionId: string,
    action: 'Download' | 'View' = 'Download'
  ): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${submissionId}/pdf`, {
      responseType: 'blob',
      params: this.getHttpParameters({ action }),
    });
  }

  markAsOpened(submissionId: string, headers?: HttpHeaders): Observable<void> {
    return this.http.patch<void>(
      `${this.apiUrl}/${submissionId}/opened`,
      null,
      { headers }
    );
  }
}
